export default __webpack_public_path__ + "static/media/4452 - RevolverX.6b59b3c5.jpeg";